export default __webpack_public_path__ + "static/online-shopping-9c348a2a4d0fc279416079a6ca0a4a77.png";